import React from 'react';
import ProductCard from '../../../components/ProductCard';
import useSiteMetadata from '../../../utils/useSiteMetaData';
import styles from './ProductCard.module.css';

/** @param {FF.ContentfulProductCard} props */
export default function ContentfulProductCard({
  contentful_id: contentfulId,
  className,
  productSku,
  fridgeMenuProduct,
}) {
  if (!fridgeMenuProduct) {
    const { siteEnv } = useSiteMetadata();
    if (['staging', 'production'].includes(siteEnv)) {
      throw new Error(
        `Error creating ProductCard with contentful_id ${contentfulId}; data from AWS not found for SKU: ${productSku}`,
      );
    } else {
      return (
        <li className={`${className} ${styles.productCardWrapper}`}>
          Product {productSku} not found
        </li>
      );
    }
  }

  return (
    <li className={`${className} ${styles.productCardWrapper}`}>
      <ProductCard
        className={styles.productCardInner}
        imageWidth={225}
        product={fridgeMenuProduct}
        withMoreInfoButton
      />
    </li>
  );
}
